import { flags } from '@hopin-team/provider-feature-flag/dist/FeatureFlagContext';

export const FLAG_REGISTRATIONS_CONFIRMATION_MESSAGE =
  'registration-confirmation-message';

export const FLAG_REGISTRATIONS_ENABLE_QUICK_CHECKOUT =
  'registrations-enable-quick-checkout';

export const FLAG_REGISTRATIONS_REUSE_FREE_ORDER =
  'registrations-enable-reuse-free-order';

export const FLAG_REGISTRATIONS_ENABLE_SEGMENT_REGISTRATION =
  'registrations-enable-segment-registration';

export const FLAG_SCHEDULES_REGISTRATION_VERSION =
  'schedules-registration-version';

export const FLAG_ENABLE_SEGMENTS_OVERLAPPING =
  'registrations-enable-segments-overlapping-check';

export const FLAG_ENABLE_HIDDEN_QUESTIONS =
  'registrations-enable-hidden-questions';

export const FLAG_QUICK_CHECKOUT_BULK_PURCHASE =
  'registrations-quick-checkout-bulk-purchase';

export const FLAG_ENABLE_BRANDING = 'registrations-enable-branding';

export const FLAG_LINKEDIN_INTEGRATION = 'linkedin-integration';

export const FLAG_REGISTRATION_FORM_LAYOUT_V2 = 'registration-form-layout-v2';

export const FLAG_TRACKING_INTEGRATIONS_V2 =
  'events-enable-tracking-integrations-v2';

export const FLAG_EVENT_SERIES = 'event-series';

export const FLAG_SERIES_PROMO_CODE =
  'registrations-enable-event-series-promo-codes';

export const FLAG_REMOVE_SCHEDULE_IN_REGISTRATION_WIDGET_FOR_SESSIONS_WITHOUT_CAPACITY =
  'remove-schedule-in-registration-widget-for-sessions-without-capacity';

export function isQuickRegistrationEnabled(flags: flags) {
  return Boolean(flags[FLAG_REGISTRATIONS_ENABLE_QUICK_CHECKOUT]);
}

export function isReuseSingleFreeOrderEnabled(flags: flags) {
  return Boolean(flags[FLAG_REGISTRATIONS_REUSE_FREE_ORDER]);
}

export function isSegmentRegistrationEnabled(flags: flags) {
  return Boolean(flags[FLAG_REGISTRATIONS_ENABLE_SEGMENT_REGISTRATION]);
}

export function isHiddenQuestionsFieldsEnabled(flags: flags) {
  return Boolean(flags[FLAG_ENABLE_HIDDEN_QUESTIONS]);
}

export const defaultFlags = {
  [FLAG_REGISTRATIONS_ENABLE_QUICK_CHECKOUT]: true,
  [FLAG_QUICK_CHECKOUT_BULK_PURCHASE]: true,
  [FLAG_ENABLE_HIDDEN_QUESTIONS]: true,
  [FLAG_REGISTRATIONS_REUSE_FREE_ORDER]: true,
  [FLAG_ENABLE_SEGMENTS_OVERLAPPING]: true,
  [FLAG_SCHEDULES_REGISTRATION_VERSION]: 'latest',
  [FLAG_ENABLE_BRANDING]: true,
  [FLAG_REGISTRATIONS_ENABLE_SEGMENT_REGISTRATION]: false,
  [FLAG_LINKEDIN_INTEGRATION]: false,
  [FLAG_REGISTRATION_FORM_LAYOUT_V2]: false,
  [FLAG_TRACKING_INTEGRATIONS_V2]: false,
  [FLAG_REGISTRATIONS_CONFIRMATION_MESSAGE]: false,
  [FLAG_EVENT_SERIES]: false,
  [FLAG_REMOVE_SCHEDULE_IN_REGISTRATION_WIDGET_FOR_SESSIONS_WITHOUT_CAPACITY]:
    false,
  [FLAG_SERIES_PROMO_CODE]: false,
};
